import styled from 'styled-components'

import { COLOURS } from 'resources'

export const Banner = styled.div`
  display: flex;
  justify-content: center;
  background-color: ${COLOURS.primaryYellow};
  align-items: center;
  min-height: 60px;
`

export const RedeemRequirementsText = styled.div`
  color: ${COLOURS.textBlack};
  font-size: 16px;
  margin: 10px 0;
`

export const TextContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
`

export const LearnMoreButton = styled.button`
  background: none;
  border: none;
  color: ${COLOURS.textBlack};
  text-decoration: underline;
  font-size: 16px;
  font-weight: bold;

  &:hover {
    text-decoration: none;
  }
`
